import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../hooks/AuthContext';
import { useAdminAccess } from '../hooks/AdminAccessContext';
import { rememberIntendedRoute } from '../utils/authRedirect';

const StatusScreen = ({ title, message, action }) => (
  <div className="login-background cq-login-shell">
    <div className="app-container login-container cq-login-container">
      <section className="cq-login-panel cq-login-panel--loading">
        <h1 className="cq-login-panel__title">{title}</h1>
        <p className="cq-login-panel__copy">{message}</p>
        {action}
      </section>
    </div>
  </div>
);

const AdminRoute = ({ children }) => {
  const { authenticatedUser, authLoading } = useAuthContext();
  const { adminError, adminLoaded, adminLoading, isAdmin } = useAdminAccess();
  const location = useLocation();

  if (authLoading || (authenticatedUser && (!adminLoaded || adminLoading))) {
    return (
      <StatusScreen
        title="Admin"
        message={authenticatedUser ? 'Checking admin access...' : 'Checking your session...'}
      />
    );
  }

  if (!authenticatedUser) {
    rememberIntendedRoute(location);
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  if (adminError && !isAdmin) {
    return (
      <StatusScreen
        title="Admin"
        message="Unable to confirm admin access right now."
        action={<Link className="cq-admin-status-link" to="/chat">Return to Cringe Quest</Link>}
      />
    );
  }

  if (!isAdmin) {
    return (
      <StatusScreen
        title="Unauthorized"
        message="You do not have access to the Admin module."
        action={<Link className="cq-admin-status-link" to="/chat">Return to Cringe Quest</Link>}
      />
    );
  }

  return children;
};

export default AdminRoute;
